import React, { useState, useEffect } from "react";
import Header from "./components/header.js";
import Navbar from "./components/navbar.js";
import Dashboard from "./components/dashboard.js";
import Customer from "./components/customer.js";
import Contact from "./components/contact.js";
import Password from "./components/password.js";
import User from "./components/user.js";
import Login from "./components/login.js";
import VerifyEmail from "./components/verifyEmail";
import styles from "./css/styles.module.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { app, db } from "./config/firebase.js";

export default function App() {
  //starting states
  const [user, setUser] = useState(null); 
  const [customerData, setCustomerData] = useState(null);
  const [customerSearch, setCustomerSearch] = useState(null);
  const [contactData, setContactData] = useState(null);
  const [contactSearch, setContactSearch] = useState(null);
  const [contactName, setContactName] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [responsibleSearch, setResponsibleSearch] = useState(null);
  const [numberSearch, setNumberSearch] = useState(null);

  //component did mount
  useEffect(() => {
    checkLoginUser();
  }, []);

  //checking to see if the user is logged in or out
  function checkLoginUser() {
    app.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser({
          userData: user,
        });
        user
          .getIdTokenResult()
          .then((claimToken) => {
            setUser((prevState) => {
              return {
                ...prevState,
                isAdmin: claimToken.claims.admin,
              };
            });
          })
          .catch((err) => {
            console.log(err);
          });
        //fetch all the data from firestore
        fetchCustomerData();
        fetchContactData();
        fetchReportData();
      } else {
        setUser(null);
      }
    });
  }

  //getting all customer data
  function fetchCustomerData() {
    db.collection("customers")
      .orderBy("name")
      .onSnapshot((snapshot) => {
        let allCustomer = [];
        let customerNames = [];
        snapshot.forEach((doc) => {
          allCustomer.push({
            id: doc.id,
            data: doc.data(),
          });
          customerNames.push(doc.data().name);
        });
        setCustomerData(allCustomer);
        setCustomerSearch(createSearchOptions(removeDuplicate(customerNames)));
      });
  }

  //getting all contact data
  function fetchContactData() {
    db.collection("contacts")
      .orderBy("name")
      .onSnapshot((snapshot) => {
        let allContact = [];
        let contactName = [];
        let contactCustomer = [];
        snapshot.forEach((doc) => {
          allContact.push({
            id: doc.id,
            data: doc.data(),
          });
          contactCustomer.push(doc.data().customer);
          contactName.push(doc.data().name);
        });
        setContactData(allContact);
        setContactSearch(createSearchOptions(removeDuplicate(contactCustomer)));
        setContactName(createSearchOptions(removeDuplicate(contactName)));
      });
  }

  //getting all sales report data
  function fetchReportData() {
    db.collection("salesReport")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        let allReport = [];
        let allResponsible = [];
        let allQTNumber = [];
        snapshot.forEach((doc) => {
          allReport.push({
            id: doc.id,
            data: doc.data(),
          });
          allResponsible.push(doc.data().responsible);
          allQTNumber.push(doc.data().qtNumber);
        });
        setReportData(allReport);
        setResponsibleSearch(removeDuplicate(allResponsible));
        setNumberSearch(removeDuplicate(allQTNumber));
      });
  }

  //remove any duplicate data from an array
  function removeDuplicate(array) {
    let temp = new Set(array);
    return Array.from(temp);
  }

  //create search label object from an array that will be used in a react-select component
  function createSearchOptions(array) {
    let temp = [];
    array.map((name) => {
      return temp.push({
        label: name,
        value: name,
      });
    });
    return temp;
  }

  if (user !== null) {
    if (user.userData.emailVerified === true) {
      return (
        <div>
          <Header />
          <div className={styles.content}>
            <Router>
              <Redirect to="/" exact />
              <Navbar user={user} />
              <Switch>
                <Route path="/" exact>
                  <Dashboard
                    data={reportData}
                    customer={customerSearch}
                    responsible={responsibleSearch}
                    qtNumber={numberSearch}
                    contactName={contactName}
                  />
                </Route>
                <Route path="/customer" exact>
                  <Customer data={customerData} search={customerSearch} />
                </Route>
                <Route path="/contact" exact>
                  <Contact
                    data={contactData}
                    search={contactSearch}
                    customer={customerSearch}
                  />
                </Route>
                <Route path="/password" exact>
                  <Password user={user} />
                </Route>
                <Route path="/user" exact>
                  <User isAdmin={user.isAdmin} />
                </Route>
              </Switch>
            </Router>
          </div>
        </div>
      );
    } else {
      return <VerifyEmail user={user} />;
    }
  } else {
    return <Login />;
  }
}
